export default __webpack_public_path__ + "static/media/gallery26.b7532cd0.jpg";